module.exports = __webpack_public_path__ + "c745c4e004e92bf6ea6edcce7f681766.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/flippers-s.png
// module id = 2395
// module chunks = 0